import { formatTime } from "@clipboard-health/date-time";
import { useEffect, useState } from "react";

export interface UseDisplayTimeProps {
  timeZone?: string;
}

export function useDisplayTime(props: UseDisplayTimeProps = {}): string | undefined {
  const { timeZone } = props;
  const [currentTime, setCurrentTime] = useState<string | undefined>(() =>
    timeZone ? formatTime(new Date(), { timeZone }) : undefined
  );

  useEffect(() => {
    if (!timeZone) {
      setCurrentTime(undefined);
      return;
    }
    setCurrentTime(formatTime(new Date(), { timeZone }));
    const intervalId = window.setInterval(() => {
      setCurrentTime(formatTime(new Date(), { timeZone }));
    }, 1000);
    return () => {
      window.clearInterval(intervalId);
    };
  }, [timeZone]);

  return currentTime;
}
